import { t } from '../copy'

export function Spinner({ size = 22, label = true, className = 'text-ink-3' }: { size?: number; label?: boolean; className?: string }) {
  return (
    <span role={label ? 'status' : undefined} aria-label={label ? t('loading') : undefined} className={`inline-flex ${className}`}>
      <svg className="spin" width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.25" strokeWidth="2.5" />
        <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
      </svg>
    </span>
  )
}

/** Centered spinner for a whole screen that is still loading. */
export function ScreenLoading() {
  return (
    <div className="flex min-h-[60dvh] items-center justify-center">
      <Spinner size={28} />
    </div>
  )
}
